<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Services
	import { postReq } from '../../../services/http';
	//Stores
		//Design system components
	import { Toggle } from '@Shelly/shelly-design-system';
	//Components
	import NetworkModal from '../NetworkComponents/NetworkModal.svelte';
	//Types
	import type { SettingRequest } from '../../../types/requests/settings/setting';
	import type { Device } from '../../../types/Device';
	import { capFirstChar } from 'src/helpers/utilities';

	$: settingsStore = getDeviceSettings(id);
	export let device: Device;
	export let isOffline;

	const id = real_id(device.id),
		settings = $settingsStore,
		saveSetting = async () => {
			let newValue = !enabled;
			const res: SettingRequest = await postReq(`/device/coiot_execute`, {
				id,
				enabled: Number(newValue),
			});

			if (res.isok) {
				enabled = newValue;
				settings.coiot_execute_enable = enabled;
			}

			onSettingsResponse(res, device);
		};

	const handleOnClick = (e) => {
		e.preventDefault();
		showModal = true;
	};

	let enabled = settings.coiot_execute_enable,
		showModal = false;
</script>

<Toggle
	size="m"
	bind:checked={enabled}
	on:click={handleOnClick}
	disabled={isOffline}
	id="toggle-xlhfw20"
>
	{$format('advanced_dev_settings_coap_listen', {
		default: 'Listen CoAp for color change commands',
	})}
</Toggle>

<NetworkModal
	btnTexts={{
		saveText: !enabled
			? capFirstChar($format('option_enable'))
			: capFirstChar($format('option_disable')),
	}}
	title={`${$format('enable_disable_copAp', {
		values: {
			enable_disable: !enabled
				? capFirstChar($format('option_enable'))
				: capFirstChar($format('option_disable')),
		},
		default: `{enable_disable} CoAp?`,
	})}`}
	bind:showModal
	on:confirm={saveSetting}
	{isOffline}
>
	{#if !enabled}
		{$format('enable_coAp_msg', {
			default: 'Are you sure you want to enable CoAp for color change for this device?',
		})}
	{:else}
		{$format('disable_coAp_msg', {
			default:
				'Disabling this will prevent the device from receiving color change commands via CoAp (Constrained Application Protocol).',
		})}
	{/if}
</NetworkModal>
